import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
} from "ngx-perfect-scrollbar";

import { CoreCommonModule } from "@core/common.module";
import { CoreTouchspinModule } from "@core/components/core-touchspin/core-touchspin.module";

import { NavbarComponent } from "app/layout/components/navbar/navbar.component";
import { NavbarBookmarkComponent } from "app/layout/components/navbar/navbar-bookmark/navbar-bookmark.component";
import { NavbarSearchComponent } from "app/layout/components/navbar/navbar-search/navbar-search.component";
import { NavbarCartComponent } from "app/layout/components/navbar/navbar-cart/navbar-cart.component";
import { NavbarNotificationComponent } from "app/layout/components/navbar/navbar-notification/navbar-notification.component";
import { TenantSelectorComponent } from "./navbar-tenant/navbar-tenant.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { AvatarComponent } from "../avatar/avatar.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CustomProgressBarComponent } from "app/layout/components/custom-progress-bar/custom-progress-bar.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
};

@NgModule({
  declarations: [
    NavbarComponent,
    NavbarSearchComponent,
    NavbarBookmarkComponent,
    NavbarCartComponent,
    NavbarNotificationComponent,
    TenantSelectorComponent,
    AvatarComponent,
    CustomProgressBarComponent,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CoreCommonModule,
    PerfectScrollbarModule,
    CoreTouchspinModule,
    NgSelectModule,
    SweetAlert2Module.forRoot(),
    FontAwesomeModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  exports: [NavbarComponent, AvatarComponent, TenantSelectorComponent, CustomProgressBarComponent],
})
export class NavbarModule {}
